var _style, _path, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizzabo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#353E50;}\n\t.st1{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.9,298.7v3.6c0,10.4-3.2,17-10.2,20.3c8.5,3.3,11.8,10.9,11.8,21.6v8.2c0,15.6-8.3,23.9-24.1,23.9h-24.9 V275.5h23.8C310.8,275.5,317.8,283.1,317.9,298.7 M286.3,289.9v26.6h6.2c5.9,0,9.5-2.6,9.5-10.7v-5.6c0-7.2-2.5-10.4-8.1-10.4H286.3 z M286.3,331v30.9h9c5.3,0,8.3-2.4,8.3-9.9v-8.8c0-9.3-3-12.2-10.2-12.2L286.3,331z M329,275.5h15.8v100.8H329V275.5z M400.3,275.5 v14.1l-30.1,72.3h30.1v14.4h-46.4v-14.1l30.1-72.3h-28.7v-14.4H400.3z M453.6,275.5v14.1l-30.1,72.3h30.1v14.4h-46.4v-14.1 l30.1-72.3h-28.7v-14.4H453.6z M514.2,376.3h-16l-2.8-18.3H476l-2.8,18.3h-14.5l16.1-100.8h23.2L514.2,376.3z M478,344.4h15.3 l-7.6-51L478,344.4z M568.9,298.7v3.6c0,10.4-3.2,17-10.2,20.3c8.5,3.3,11.8,10.9,11.8,21.6v8.2c0,15.6-8.2,23.9-24.1,23.9h-24.9 V275.5h23.9C561.9,275.5,568.9,283.1,568.9,298.7 M537.4,289.9v26.6h6.2c5.9,0,9.5-2.6,9.5-10.7v-5.6c0-7.2-2.5-10.4-8.1-10.4H537.4 z M537.4,331v30.9h9.1c5.3,0,8.2-2.4,8.2-9.9v-8.8c0-9.3-3-12.2-10.2-12.2L537.4,331z M578.7,299.7c0-16.1,8.5-25.3,24-25.3 c15.5,0,24.1,9.2,24.1,25.3v52.4c0,16.1-8.5,25.3-24.1,25.3s-24-9.2-24-25.3V299.7z M594.6,353.1c0,7.2,3.2,9.9,8.2,9.9 s8.3-2.8,8.3-9.9v-54.4c0-7.2-3.2-9.9-8.3-9.9c-5.1,0-8.2,2.8-8.2,9.9V353.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M83.5,373.6c-1.3-2.4-1.2-5.3,0.3-7.5l38.6-58.5c2.2-3.4,6.8-4.3,10.2-2.1c3.4,2.2,4.3,6.8,2.1,10.2 l-31.1,47h80.4c4.1,0,7.4,3.3,7.4,7.4c0,4.1-3.3,7.4-7.4,7.4H90C87.3,377.5,84.8,376,83.5,373.6 M82.6,281.7 c0-4.1,3.3-7.4,7.3-7.4c0,0,0,0,0,0h94.1c4.1,0,7.4,3.3,7.4,7.4c0,1.4-0.4,2.9-1.2,4.1l-38.5,58.5c-2.1,3.5-6.6,4.6-10.1,2.5 c-3.5-2.1-4.6-6.6-2.5-10.1c0.1-0.2,0.2-0.3,0.3-0.5l31-47H90C85.9,289.1,82.7,285.8,82.6,281.7C82.6,281.8,82.6,281.7,82.6,281.7  M26.8,325.9c0,60.9,49.4,110.3,110.3,110.3s110.3-49.4,110.3-110.3S198,215.7,137.1,215.7S26.8,265,26.8,325.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -440.8789,
    y1: 665.5715,
    x2: -439.5006,
    y2: 665.5715,
    gradientTransform: "matrix(160 0 0 -160 70567.1484 106817.3594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3BC9CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3399CC"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 215.7,
    className: "st1",
    width: 220.5,
    height: 220.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizzabo);
export default __webpack_public_path__ + "static/media/bizzabo.9545becfae0cc428bd67de6f80efefe3.svg";
export { ForwardRef as ReactComponent };